"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrbitalCleanupRebalanced = void 0;
var Tags_1 = require("../../Tags");
var Card_1 = require("../../Card");
var CardType_1 = require("../../CardType");
var Resources_1 = require("../../../Resources");
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var OrbitalCleanupRebalanced = (function (_super) {
    __extends(OrbitalCleanupRebalanced, _super);
    function OrbitalCleanupRebalanced() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.ORBITAL_CLEANUP_REBALANCED,
            tags: [Tags_1.Tags.EARTH, Tags_1.Tags.SPACE],
            cost: 14,
            metadata: {
                cardNumber: 'X08',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Gain 1 M€ per every two Science tag you have.', function (eb) {
                        eb.empty().startAction.megacredits(1).slash().science(2).played;
                    });
                }),
                victoryPoints: 2,
            },
        }) || this;
    }
    OrbitalCleanupRebalanced.prototype.play = function () {
        return undefined;
    };
    OrbitalCleanupRebalanced.prototype.canAct = function () {
        return true;
    };
    OrbitalCleanupRebalanced.prototype.action = function (player) {
        player.addResource(Resources_1.Resources.MEGACREDITS, Math.floor(player.getTagCount(Tags_1.Tags.SCIENCE) / 2), { log: true });
        return undefined;
    };
    OrbitalCleanupRebalanced.prototype.getVictoryPoints = function () {
        return 2;
    };
    return OrbitalCleanupRebalanced;
}(Card_1.Card));
exports.OrbitalCleanupRebalanced = OrbitalCleanupRebalanced;
//# sourceMappingURL=OrbitalCleanupRebalanced.js.map